const servicesData = [
  {
    header: "Installation + Replacement",
    headerSp: "Instalación + Reemplazo",
    content:
      "We will provide an exam before deciding to replace your unit. If needed, our skilled technicians have been trained to install the highest rated appliances",
    contentSp:
      "Le proporcionaremos un examen antes de decidir reemplazar su unidad.  Si es necesario, nuestros técnicos calificados han sido capacitados para instalar los mas modernos electrodomésticos.",
    id: 1,
  },
  {
    header: "Repair + Maintenance",
    headerSp: "Reparación + Mantenimiento",
    content:
      "Not only will we keep everything running at full capacity but we will offer insight on what you can do to keep your unit maintained between visits",
    contentSp:
      "No solo mantendremos todo funcionando perfectamente, sino que le ofreceremos información sobre lo que puede hacer para mantener su unidad en buen estado entre visitas.",
    id: 2,
  },
  {
    header: "Air Quality",
    headerSp: "Calidad Del Aire",
    content:
      "Avoid common household allergens with a scheduled duct cleaning, filter replacements, and damper adjustments",
    contentSp:
      "Evite los alérgenos domésticos comunes con una limpieza programada de los conductos de su unidad, reemplazos de filtros y ajustes de amortiguadores",
    id: 3,
  },
];

export default servicesData;
